define(['jquery',
        'core/urls',
        'core/dynamic-forms'],
    function($, urls) {

        function autotaskConnectivityCheck(){
            $.ajax({
                type: 'GET',
                url: urls['ticketsource:autotask-connectivity'](),
                dataType: 'json',
                success: function(data){
                     if(data.status === 'connected'){
                        $('#connectivity-status-checking-autotask').hide();
                        $('#connectivity-status-autotask p').hide();
                        $('#connectivity-status-connected-autotask').show();
                        $('#connectivity-status-notconnected-autotask').hide();
                    } else if(data.status === 'disconnected') {
                        $('#connectivity-status-checking-autotask').hide();
                        $('#connectivity-status-notconnected-autotask').show();
                        $('#connectivity-status-checking-autotask').hide();
                        $('#connectivity-status-autotask p').show();
                    }
                }
            });
        }

        return {
            init: function() {
                autotaskConnectivityCheck();
                $(document).on('valid', 'form', function() {
                    autotaskConnectivityCheck();
                    if(!globals.has_generated_snippet) {
                        $('#continueToSurveyButton').prop('disabled', false);
                        $('#skipApiSetupLink').hide();
                    }
                });
            }
        };
    }
);